import { styled, css } from 'styled-components';
import { ArrayContainer } from '@template/blocks/DragAndDropAccordion/styles.ts';
import {
  InputLabel,
  InputWrapper,
  InputContainer,
} from '@template/components/Input/styles.ts';
import { Wrapper as SwitchWrapper } from '@template/components/Switch/styles.ts';

export const Wrapper = styled.div`
  width: 100%;
  height: max-content;
  min-height: 32px;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.default[0]};
  padding: 12px;

  ${InputWrapper} {
    width: 100%;
  }

  ${SwitchWrapper} {
    background: ${({ theme }) => theme.colors.default[50]};
    border: 1px solid ${({ theme }) => theme.colors.default[50]};
    padding: 10px 14px;
    transition: 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.base};
    }

    ${InputLabel} {
      color: ${({ theme }) => theme.colors.default[400]};
    }
  }
`;

export const SelectWrapper = styled(Wrapper)``;

export const GroupInputTrigger = styled.button<{ $isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.default[600]};

  svg {
    transition: 0.2s;
    transform-origin: center center;
    height: 100%;
  }

  ${({ $isOpen, theme }) =>
    $isOpen &&
    css`
      svg {
        transform: rotate(180deg);
      }
    `}
`;

export const GroupWrapper = styled(Wrapper)`
  gap: 12px;
  display: flex;
  flex-direction: column;

  > div > ${ArrayContainer} {
    padding: 8px;
    gap: 1px;
  }

  ${ArrayContainer} {
    ${Wrapper} {
      ${SwitchWrapper} {
        background: ${({ theme }) => theme.colors.base};
        border: 1px solid ${({ theme }) => theme.colors.base};
        padding: 10px 14px;
        transition: 0.2s;

        &:hover {
          background: ${({ theme }) => theme.colors.default[50]};
        }
      }
    }
  }
`;
